__turbopack_context__.v({
  "placeholder": "PlasmicLoadingPlaceholder-module__KfZMMW__placeholder",
});
